module.exports = __webpack_public_path__ + "static/img/Ricky-Mentha.953f53d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ricky-Mentha.jpg
// module id = hRIc
// module chunks = 0